import { quickSearch } from '../../services/Search'
import HeaderSearchField from './HeaderSearchField'

const HeaderQuickSearch = () => (
  <HeaderSearchField
    searchFn={quickSearch}
    placeholder="Syötä puhelinnumero, rekisteritunnus tai kohde"
    queryKeyPrefix="quickSearch"
  />
)

export default HeaderQuickSearch
